module.exports = __webpack_public_path__ + "img/summary-treatment-modal-mobile.ad565318.jpg";